import { forwardRef, SelectHTMLAttributes } from 'react';
import styles from "./FormField.module.css";
import { Form } from 'react-bootstrap';
import cn from 'classnames';
import { IFieldTheme } from './FormField';

interface IFormSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  placeholder?: string;
  showError?: boolean;
  errorText?: string;
  disabled?: boolean;
  fieldTheme?: IFieldTheme;
  defaultValue?: string | number;
  className?: string;
}

const FormSelect = forwardRef<HTMLSelectElement, IFormSelectProps>((props, ref) => {
  const {
    fieldTheme = IFieldTheme.DEFAULT,
    label,
    placeholder,
    showError,
    errorText,
    disabled,
    className,
    children,
    defaultValue,
    value,
    ...restProps
  } = props;

  const isControlled = value !== undefined;

  return (
    <div className={cn(styles.formField, styles.selectField, className, styles[fieldTheme])}>
      {label && <Form.Label className={styles.label}>{label}</Form.Label>}

      <select
        ref={ref}
        disabled={disabled}
        className={cn('form-control', styles.formControl, disabled && styles.disabled)}
        {...restProps}
        {...(isControlled ? { value: value } : { defaultValue: defaultValue || "" })}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {children}
      </select>

      {showError && <div className={styles.errorText}>{errorText}</div>}
    </div>
  );
});

export default FormSelect;
